import { MenuDivider, MenuEntry, MenuItem } from '@tableau/hybrid-widgets-contract';
import { MenuItemInfo } from '@tableau/widgets';

function assertNever(x: never): never {
  throw new Error('Unexpected object: ' + x);
}

export const encodeSvg = (svg?: string) => !svg ? undefined : `data:image/svg+xml,${encodeURIComponent(svg)}`;

export function entryToWidgetsMenuItem(entry: MenuEntry): MenuItemInfo {
  const item: MenuItemInfo = {
    annotation: entry.annotation?.type === 'imageResourceKey' ? undefined :
      entry.annotation?.type === 'svg' ? encodeSvg(entry.annotation?.contents) : entry.annotation?.contents,
    checked: entry.checked,
    disabled: entry.disabled,
    displayValue: entry.displayValue,
    icon: entry.icon?.type === 'imageResourceKey' ? undefined : encodeSvg(entry.icon?.contents),
    title: entry.tooltip,
    value: entry.key,
  };
  if (entry.subMenuItems !== undefined) {
    item.menuItemInfos = menuItemsToWidgetsMenuItems(entry.subMenuItems);
  }
  return item;
}

function dividerToWidgetsMenuItem(_: MenuDivider): MenuItemInfo {
  return { isDivider: true };
}

export function menuItemsToWidgetsMenuItems(items: Array<MenuItem>): Array<MenuItemInfo> {
  return items.map((item: MenuItem) => {
    switch (item.type) {
      case 'entry':
        return entryToWidgetsMenuItem(item);
      case 'divider':
        return dividerToWidgetsMenuItem(item);
      default:
        assertNever(item);
        // Not reachable due to above assert.
        return {};
    }
  });
}

function findMenuEntryInTree(key: string, item: MenuItem): MenuEntry | null {
  if (item.type !== 'entry') {
    return null;
  }

  if (item.key === key) {
    return item;
  }

  if (item.subMenuItems) {
    return findMenuEntry(key, item.subMenuItems);
  }

  return null;
}

/** Basically a DFS on menu items - returns Entry with matching key or null if not found  */
export function findMenuEntry(key: string, items: Array<MenuItem>): MenuEntry | null {
  for (const item of items) {
    const foundItem = findMenuEntryInTree(key, item);
    if (foundItem !== null) {
      return foundItem;
    }
  }
  return null;
}
